import useDataset from "datasets/hooks/useDataset";

/**
 * Returns whether the current user has the given permission on the active dataset,
 * as determined by the Catalog API's `actions_permitted` response.
 *
 * Defaults to `false` when the dataset has not loaded or the permission is absent.
 *
 * `id` overrides the route-fetched dataset — required when called outside the
 * `/datasets/:datasetId` route tree (e.g. the session context sidebar), since
 * `useDataset()` otherwise has no `:datasetId` param to fall back on.
 */
const useDatasetPermission = (permission: string, id?: string): boolean => {
  const { data: dataset } = useDataset(id);
  return !!dataset?.actions_permitted.includes(permission);
};

export default useDatasetPermission;
